import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import { NewsletterSubscribeSection } from "src/components/newsletter-subscribe-section";
import { Seo } from "src/components/seo";
import { usePageView } from "src/hooks/use-page-view";

const NewsletterPage = () => {
  usePageView();

  return (
    <>
      <Seo
        title="Newsletter Subscription"
        description="Subscribe to the OpenSource.Clinic newsletter for updates and new resources."
      />
      <Box
        component="main"
        sx={{
          pt: { xs: 12, md: 14 },
        }}
      >
        <Container maxWidth="md" sx={{ pb: 2 }}>
          <NewsletterSubscribeSection />
        </Container>
      </Box>
    </>
  );
};

export default NewsletterPage;
